import {useRouter} from 'next/router';
import {dictionary, TranslationKeys} from 'translations';
import {getProductPluralForm, getProductPluralFormEn, getProductPluralFormRo} from 'utils/pluralization';

export const useTranslation = () => {
  const {locale} = useRouter();

  return {
    t: (term: TranslationKeys) => {
      if (!locale) return term;

      const translation = dictionary[locale][term];
      return translation;
    },
    getProductPlural: (count: number) => {
      if (!locale) return 'Продукт';

      switch (locale) {
        case 'ru':
          return getProductPluralForm(count);
        case 'en':
          return getProductPluralFormEn(count);
        case 'ro':
          return getProductPluralFormRo(count);
        default:
          return getProductPluralForm(count);
      }
    },
    locale,
  };
};
